export default __webpack_public_path__ + "static/media/ktj.43ad3e8d.jpg";